// extracted by mini-css-extract-plugin
export default {"root":"BroadcastingChannelsList_root__73dQv","overlay":"BroadcastingChannelsList_overlay__-hv-m"};